import React from 'react';

const AcceptModal = ({ dealerEmail }) => {
    return (
        <div className="modal fade" id="accept_modal" tabIndex={-1} role="dialog" aria-labelledby="accept_modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <img src="/images/offer-accepted.png" alt="check" style={{ marginLeft: '18px', marginRight: '32px' }} width="100px" />
                        <h6 className="modal-title">
                            Congratulations! Please check&nbsp;
                            {dealerEmail ? <span className="text-primary">{dealerEmail}</span> : "your dealership's email"}
                            &nbsp;for your closing documents. Our team is eager to work your deal and provide you with the best 
                            service possible. To ensure a smooth and efficient process, we kindly request that you send all 
                            required documents and stipulations to&nbsp;
                            <a href="mailto:Autocreditfunding@usautocreditcorp.com" className="text-primary">Autocreditfunding@usautocreditcorp.com</a>&nbsp;
                            as soon as possible.
                        </h6>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" type="button" data-bs-dismiss="modal">OK</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(AcceptModal);